import React from "react";
import AutomotiveSvg from "assets/svg/automotive";
import EcomSvg from "assets/svg/ecom";
import FinanceSvg from "assets/svg/finance";
import FmcgSvg from "assets/svg/fmcg";
import GamingSvg from "assets/svg/gaming";
import GovtSvg from "assets/svg/government";
import HospSvg from "assets/svg/hospitality";
import LogsSvg from "assets/svg/logistics";
import ManufactureSvg from "assets/svg/manufacture";
import MedSvg from "assets/svg/medicine";
import MilitarySvg from "assets/svg/military";
import TechSvg from "assets/svg/tech";
import { Link } from "gatsby";

export default function ServicesGrid({
  heading,
  details,
  contactUs,
  backgroundCol,
  colorComp,
  dangerouslySetDetails,
}) {
  return (
    <section
      className={`${
        backgroundCol ? backgroundCol : "bg-services-pattern"
      } bg-no-repeat bg-cover py-20`}
    >
      <div className="container mx-auto px-4 grid grid-cols-1 gap-8 md:w-full lg:max-w-6xl lg:grid-cols-2 lg:place-items-center">
        <div className="text-center lg:text-left h-auto lg:mr-24 md:h-auto  lg:h-[24rem]">
          <h2 className="text-gray text-[35px] font-bold font-secondary mb-6 lg:leading-normal">
            {heading ? heading : "A Translation Services Company for every"}
            {colorComp ? (
              <span className="text-orange">
                {" "}
                {colorComp ? colorComp : "Industry"}
              </span>
            ) : null}
          </h2>
          {dangerouslySetDetails ? (
            <p
              className="text-[#BEBEBE] font-opensans text-[16px] text-center lg:text-left py-2 pb-4 leading-[30px]"
              dangerouslySetInnerHTML={{
                __html: details
                  ? details
                  : "Our community of professionals commands expertise in virtually every industry imaginable, masters in the terminology of every field, including your own. We guarantee it.",
              }}
            />
          ) : (
            <p className="text-[#BEBEBE] font-opensans text-[16px] text-center lg:text-left py-2 pb-4 leading-[30px]">
              {details
                ? details
                : "Our community of professionals commands expertise in virtually every industry imaginable, masters in the terminology of every field, including your own. We guarantee it."}
            </p>
          )}

          {contactUs ? (
            <button
              to="/"
              className="bg-orange rounded-full text-[14px] font-semibold text-white px-10 py-3 mt-[20px]"
            >
              <Link to="/contactus.php">CONTACT US</Link>
            </button>
          ) : null}
        </div>
        <div className="grid grid-cols-2 gap-2 text-center md:grid-cols-3">
          <Link
            to="/industries/technology"
            className="border-solid border hover:bg-black  hover:border-black border-gridborderColor px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <TechSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Technology
            </p>
          </Link>
          <Link
            to="/industries/government"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <GovtSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Government
            </p>
          </Link>
          <Link
            to="/industries/military"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <MilitarySvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Military
            </p>
          </Link>
          <Link
            to="/industries/healthcare"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <MedSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Medicine
            </p>
          </Link>
          <Link
            to="/industries/banking-finance"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <FinanceSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Finance
            </p>
          </Link>
          <Link
            to="#"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <ManufactureSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Manufacturing
            </p>
          </Link>
          <Link
            to="/industries/automotive"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <AutomotiveSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Automotive
            </p>
          </Link>
          <Link
            to="#"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <HospSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Hospitality
            </p>
          </Link>
          <Link
            to="/industries/gaming"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <GamingSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Gaming
            </p>
          </Link>
          <Link
            to="#"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <LogsSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              Logistics
            </p>
          </Link>
          <Link
            to="#"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <FmcgSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              FMCG
            </p>
          </Link>
          <Link
            to="#"
            className="border-solid border border-gridborderColor hover:bg-black  hover:border-black px-12 py-4 cursor-pointer flex flex-col justify-center items-center"
          >
            <EcomSvg />
            <p className="text-[#E6E6E6] font-opensans font-extrabold text-xs  text-center py-2">
              E-Commerce
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
}
